import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { PopOutController } from "../../shared/popOutController";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { StringEnums } from "../../shared/utilities/enums/stringEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { TimeUtils } from "../../shared/utilities/timeUtils";
import { AjaxPopOutCarouselGallery, IAjaxPopOutCarouselGallery } from "./ajaxPopOutCarouselGallery";
import { IPagingCarouselGalleryWithZoomButton, PagingCarouselGalleryWithZoomButton } from "./pagingCarouselGalleryWithZoomButton";

export interface IZoomableGallery extends IInstanceComponentBase {
    embeddedCarouselGallery: IPagingCarouselGalleryWithZoomButton;
    popOutGallery?: IAjaxPopOutCarouselGallery;
    carouselCurrentSelectedIndex: number;
}

export class ZoomableGallery extends InstanceComponentBase implements IZoomableGallery {

    embeddedCarouselGallery: IPagingCarouselGalleryWithZoomButton;
    popOutGallery: IAjaxPopOutCarouselGallery;
    carouselCurrentSelectedIndex: number;

    private readonly _popOutGalleryFactory;
    private readonly _updateCarouselCurrentSelectedIndexFromEvent;
    constructor(public htmlElement: Element) {
        super(htmlElement);


        this._popOutGalleryFactory = this.popOutGalleryFactory.bind(this);
        this._updateCarouselCurrentSelectedIndexFromEvent = this.updateCarouselCurrentSelectedIndexFromEvent.bind(this);

        this.embeddedCarouselGallery = this.embeddedCarouselGalleryFactory();
        this.attachSelectedCarouselCellSelectedEventListener();
        this.attachZoomButtonPressedEventListner();
    }
    attachSelectedCarouselCellSelectedEventListener(): void {
        console.log('SelectableCarousel: attachSelectedCarouselCellSelectedEventListener');
        this.htmlElement.addEventListener(CustomEventEnums.SelectedCarouselCellSelected, this._updateCarouselCurrentSelectedIndexFromEvent);
    }

    removeSelectedCarouselCellSelectedEventListener(): void {
        console.log('SelectableCarousel: removeSelectedCarouselCellSelectedEventListener');
        this.htmlElement.removeEventListener(CustomEventEnums.SelectedCarouselCellSelected, this._updateCarouselCurrentSelectedIndexFromEvent);
    }
    attachZoomButtonPressedEventListner(): void {
        this.htmlElement.addEventListener(CustomEventEnums.ZoomButtonPressed, this._popOutGalleryFactory);
    }
    removeZoomButtonPressedEventListner(): void {
        this.htmlElement.removeEventListener(CustomEventEnums.ZoomButtonPressed, this._popOutGalleryFactory);
    }
    async popOutGalleryFactory(): Promise<void> {

        await this.setpopOutGalleryZIndex();

        if (!this.popOutGallery) {
            ((<any>window).popOutController as PopOutController).closeAllMenus();

            let popOutGalleryElementPlaceholder: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ZoomableGallery.ZoomableGalleryPopOutPlaceholder));

            await AjaxPopOutCarouselGallery.getPopOutCarouselHtml(popOutGalleryElementPlaceholder);
            let popOutGalleryElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PopOutCarouselGallery.PopOutCarouselGallery));

            let popOutGallery = await new AjaxPopOutCarouselGallery(popOutGalleryElement, this.carouselCurrentSelectedIndex, this.htmlElement as HTMLElement);
            this.popOutGallery = popOutGallery;
            this._updateCarouselCurrentSelectedIndexFromEvent;
        } else {
            
            // Move carousel to position after css transition has completed
            await TimeUtils.sleep(300);
            this.popOutGallery.singlePagingSelectableCarousel.moveToPosition();

        }
    }

    async setpopOutGalleryZIndex(): Promise<void> {
        
        let popOutGalleryParent: HTMLElement = this.htmlElement.closest(HelperUtils.addCssClassDot(StringEnums.CssClass.LbProductPageLayoutGallery));
        popOutGalleryParent.style.zIndex = '20';
    };

    embeddedCarouselGalleryFactory(): IPagingCarouselGalleryWithZoomButton {
        let embeddedCarouselGalleryElement: HTMLElement = this.htmlElement.querySelector(`[${AttributeEnums.PagingCarouselGalleryWithZoomButton.PagingCarouselGalleryWithZoomButton}]`) as HTMLElement;
        return new PagingCarouselGalleryWithZoomButton(embeddedCarouselGalleryElement, this.htmlElement as HTMLElement);
    }

    updateCarouselCurrentSelectedIndexFromEvent(event: CustomEvent) {
        console.log('SelectableCarousel: updateCarouselCurrentSelectedIndexFromEvent - event', event);
        const selectedIndex: number = event.detail.selectedIndex as number;
        this.updateCarouselCurrentSelectedIndex(selectedIndex);
    }

    updateCarouselCurrentSelectedIndex(index: number) {
        this.carouselCurrentSelectedIndex = index;
        if (this.popOutGallery) {
            this.popOutGallery.updateCarouselCurrentSelectedIndex(index);
        }
    }

    dispose(): void {
        this.popOutGallery.dispose();
        this.removeZoomButtonPressedEventListner();
        this.removeSelectedCarouselCellSelectedEventListener();
    }

    delete(): void {

    }
}